const genres = [
  {
    id: 1,
    title: "Podcasts",
    image: "https://t.scdn.co/images/ad4d5c268a214f78920517e76e6ed107.jpeg",
    background: "rgb(245, 155, 35)",
  },
  {
    id: 2,
    title: "Made for You",
    image: "https://t.scdn.co/images/68433b0ee5b5465b8e926c42b84cbcdb.jpeg",
    background: "rgb(160, 195, 210)",
  },
  {
    id: 3,
    title: "Charts",
    image: "https://t.scdn.co/images/4b7472015a274eadbc00119f5141e548.jpeg",
    background: "rgb(75, 145, 125)",
  },
  {
    id: 4,
    title: "New Releases",
    image: "https://t.scdn.co/images/acc7b5d7b1264d0593ec05c020d0a689.jpeg",
    background: "rgb(160, 195, 210)",
  },
  {
    id: 5,
    title: "Discover",
    image: "https://t.scdn.co/images/d0fb2ab104dc4846bdc56d72b0b0d785.jpeg",
    background: "rgb(180, 155, 200)",
  },
  {
    id: 6,
    title: "Concerts",
    image: "https://t.scdn.co/images/60075fbc12304968941c7445a971fb9d.jpeg",
    background: "rgb(255, 100, 55)",
  },
  {
    id: 7,
    title: "EQUAL",
    image: "https://t.scdn.co/images/8868297db4ba465c853fbb18e6ed54f2",
    background: "rgb(25, 230, 140)",
  },
  {
    id: 8,
    title: "Punjabi",
    image: "https://t.scdn.co/images/fc525ffce9f74e0792b9438ae541a5b1.jpeg",
    background: "rgb(175, 40, 150)",
  },
  {
    id: 9,
    title: "Tamil",
    image: "https://t.scdn.co/images/2009b6515219438382ad57192173de13.jpeg",
    background: "rgb(255, 200, 100);",
  },
  {
    id: 10,
    title: "Telugu",
    image: "https://t.scdn.co/images/a33f9b9872a84bba9a4e058d4f863915.jpeg",
    background: "rgb(25, 230, 140)",
  },
  {
    id: 11,
    title: "Radar",
    image: null,
    background: "rgb(83, 83, 83)",
  },
  {
    id: 12,
    title: "Marathi",
    image: null,
    background: "rgb(83, 83, 83)",
  },
  {
    id: 13,
    title: "Devotional",
    image: null,
    background: "rgb(83, 83, 83)",
  },
  {
    id: 14,
    title: "Indian Classical",
    image: null,
    background: "rgb(83, 83, 83)",
  },
  {
    id: 15,
    title: "Romance",
    image: "https://t.scdn.co/images/f926c0d460ae4f1abd83ffc3c1affdf0.jpeg",
    background: "rgb(245, 115, 160)",
  },
  {
    id: 16,
    title: "K-Pop",
    image: "https://t.scdn.co/images/6dc62cc4c21c4b08a1873a618ac65a09",
    background: "rgb(205, 245, 100)",
  },
  {
    id: 17,
    title: "Party",
    image: "https://t.scdn.co/images/d6cf42772b014925b59ee2a247a9850a.jpeg",
    background: "rgb(240, 55, 165)",
  },
  {
    id: 18,
    title: "Instrumental",
    image: "https://i.scdn.co/image/ab67706f000000038ed1a5002b96c2ea882541b2",
    background: "rgb(160, 195, 210)",
  },
  {
    id: 19,
    title: "Dance / Electronic",
    image: "https://t.scdn.co/images/3c419cbc46e5430795e056298c34702d.jpeg",
    background: "rgb(155, 240, 225)",
  },
  {
    id: 20,
    title: "Decades",
    image: "https://t.scdn.co/images/5174463a68e449bf8ee0ae85cd6d7b48.jpeg",
    background: "rgb(180, 155, 200)",
  },
  {
    id: 21,
    title: "Student",
    image: null,
    background: "rgb(83, 83, 83)",
  },
  {
    id: 22,
    title: "Higher Ground",
    image: "https://i.scdn.co/image/4f26db8239305bef29ef956b331b31407cbf51f9",
    background: "rgb(160, 195, 210)",
  },
  {
    id: 23,
    title: "Hip Hop",
    image: "https://t.scdn.co/images/9676cef74ec147a48607c737c4f93943.jpeg",
    background: "rgb(245, 155, 35)",
  },
  {
    id: 24,
    title: "Workout",
    image: "https://t.scdn.co/images/0093f59664854b619e34a51d39d35a2f.jpeg",
    background: "rgb(255, 200, 100)",
  },
  {
    id: 25,
    title: "At Home",
    image: "https://t.scdn.co/images/194b9d722de34cefb3b716c653b4526b.png",
    background: "rgb(245, 155, 35)",
  },
  {
    id: 26,
    title: "Folk & Acoustic",
    image: "https://t.scdn.co/images/7d6832ae5da44e748888723f555a9cdc.jpeg",
    background: "rgb(75, 145, 125)",
  },
  {
    id: 27,
    title: "Sleep",
    image: "https://t.scdn.co/images/6c53e335de834419a521e776668cca75.jpeg",
    background: "rgb(160, 195, 210)",
  },
  {
    id: 28,
    title: "Kids & Family",
    image: "https://t.scdn.co/images/f4393ac2106e4583ac86e2ddd7ae827d.jpeg",
    background: "rgb(175, 40, 150)",
  },
  {
    id: 29,
    title: "R&B",
    image: "https://t.scdn.co/images/92a6fd8aaffe403ba1967c70097f90f9.jpeg",
    background: "rgb(240, 55, 165)",
  },
  {
    id: 30,
    title: "Tastemakers",
    image: "https://t.scdn.co/images/7ef1d6445a684e30bdd78f09507d688c.jpeg",
    background: "rgb(235, 30, 50)",
  },
  {
    id: 31,
    title: "Wellness",
    image: "https://t.scdn.co/images/31580c92008a4722a7b3919c8d0388e8.png",
    background: "rgb(180, 155, 200)",
  },
  {
    id: 32,
    title: "Rock",
    image: "https://t.scdn.co/images/31c85ae6fec34a16927ef28a7a88e97b.jpeg",
    background: "rgb(235, 30, 50)",
  },
  {
    id: 33,
    title: "Caribbean",
    image: "https://t.scdn.co/images/c2f465d82eef4adeae4b881de494137e.jpeg",
    background: "rgb(155, 240, 225)",
  },
  {
    id: 34,
    title: "Mood",
    image: "https://t.scdn.co/images/baf681efc57145e180589e027496b101.jpeg",
    background: "rgb(80, 155, 245)",
  },
  {
    id: 35,
    title: "Chill",
    image: "https://t.scdn.co/images/2470fe22d03a4375a9501dce8cfb2b8c.jpeg",
    background: "rgb(160, 195, 210)",
  },
  {
    id: 36,
    title: "Focus",
    image: "https://t.scdn.co/images/cf23ab0343e047daa88703e21c01a4aa.jpeg",
    background: "rgb(180, 155, 200)",
  },
  {
    id: 37,
    title: "Summer",
    image: "https://t.scdn.co/images/a2a24668f16c4e9680233a0d7d244a4b.jpeg",
    background: "rgb(255, 200, 100)",
  },
  {
    id: 38,
    title: "Cooking & Dinning",
    image: "https://t.scdn.co/images/63215314950a4872986eeaff17ef8059.jpeg",
    background: "rgb(255, 200, 100)",
  },
  {
    id: 39,
    title: "Jazz",
    image: "https://t.scdn.co/images/0f2f4c71c9714cc5b757f7bb3559fcdb.jpeg",
    background: "rgb(160, 195, 210)",
  },
  {
    id: 40,
    title: "Gaming",
    image: "https://t.scdn.co/images/9e364b88527c4314b6caa40e935f3624.png",
    background: "rgb(155, 240, 225)",
  },
  {
    id: 41,
    title: "Soul",
    image: "https://t.scdn.co/images/aa6811c21031431b817f5f152e93701f.jpeg",
    background: "rgb(240, 55, 165)",
  },
  {
    id: 42,
    title: "Classical",
    image: "https://t.scdn.co/images/d7d44d00eb0542aeab69ed5c8654d104.jpeg",
    background: "rgb(180, 155, 200)",
  },
  {
    id: 43,
    title: "Latin",
    image: "https://t.scdn.co/images/1d7841c92c504343a391dfa0626fc22c.jpeg",
    background: "rgb(255, 100, 55)",
  },
  {
    id: 44,
    title: "Metal",
    image: "https://t.scdn.co/images/ad4d5c268a214f78920517e76e6ed107.jpeg",
    background: "rgb(245, 155, 35)",
  },
  {
    id: 45,
    title: "Blues",
    image: "https://t.scdn.co/images/a91f8b3da9da4ebcb12ee6ad8ac6d3c0.jpeg",
    background: "rgb(160, 195, 210)",
  },
  {
    id: 46,
    title: "Funk",
    image: "https://t.scdn.co/images/07b5a850818e4ec28b5ff37735f7716f.jpeg",
    background: "rgb(240, 55, 165)",
  },
  {
    id: 47,
    title: "Punk",
    image: "https://t.scdn.co/images/1383b2c0e0954accad7e7a05387c0c4e.jpeg",
    background: "rgb(111, 111, 111)",
  },
  {
    id: 48,
    title: "Travel",
    image: "https://t.scdn.co/images/296edba89b464025865781eee1b2a2a1.jpeg",
    background: "rgb(255, 200, 100)",
  },
  {
    id: 49,
    title: "Country",
    image: "https://t.scdn.co/images/4afff64d33e74356905bc257646d476c.jpeg",
    background: "rgb(255, 200, 100)",
  },
  {
    id: 50,
    title: "Anime",
    image: null,
    background: "rgb(83, 83, 83)",
  },
  {
    id: 51,
    title: "Songwriters",
    image: "https://i.scdn.co/image/ab676d63000014756cbb07bea33ce82336db23d2",
    background: "rgb(255, 200, 100)",
  },
  {
    id: 52,
    title: "TV & Movies",
    image: "https://t.scdn.co/images/8006df4fbf8d456fb36fc46e3cb5cd8a.jpeg",
    background: "rgb(240, 55, 165)",
  },
];

export default genres;
